import { Divider, Drawer, IconButton, Stack, styled, ClickAwayListener } from "@mui/material";
import React, { ReactNode } from "react";
import { MdChevronRight } from "react-icons/md";
import { useTranslations } from "next-intl";
import { useTheme } from "@patron/utils/theme";
import { CustomTypographyComponent } from "@patron/ui/text";

interface SideSheetCompomentProps {
  children: ReactNode;
  drawerOpen: boolean;
  drawerTitle: string;
  width?: number;
  useClickAwayOff?: boolean;
  hideOverflow?: boolean;
  height?: any;
  disableTitleTranslation?: boolean;
  onDrawerClosed: () => void;
  headerButtons?: React.ReactNode;
}

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-start",
}));

export const SideSheetCompoment = ({
  children,
  drawerOpen,
  hideOverflow,
  height,
  useClickAwayOff,
  onDrawerClosed,
  drawerTitle,
  width,
  disableTitleTranslation = false,
  headerButtons,
}: SideSheetCompomentProps) => {
  const drawerWidth = width || 300;
  const t = useTranslations("common");
  const theme = useTheme();

  return (
    <ClickAwayListener
      mouseEvent="onMouseDown"
      touchEvent="onTouchStart"
      onClickAway={() => (useClickAwayOff ? null : onDrawerClosed())}
    >
      <Drawer
        sx={{
          // width: drawerWidth,
          overflow: hideOverflow ? "hidden" : "auto",
          height: height || "100%",
          flexShrink: 0,
          position: "fixed",
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            overflow: hideOverflow ? "hidden" : "auto",
            height: "99%",
            marginTop: "45px",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            position: "fixed",
            zIndex: theme.zIndex.drawer,
          },
        }}
        variant="temporary"
        anchor="right"
        onClose={onDrawerClosed}
        open={drawerOpen}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <DrawerHeader sx={{ justifyContent: "space-between", direction: "row", alignItems: "center" }}>
          <Stack direction={"row"} alignItems={"center"}>
            <IconButton onClick={onDrawerClosed}>
              <MdChevronRight />
            </IconButton>
            <CustomTypographyComponent>{disableTitleTranslation ? drawerTitle : t(drawerTitle)}</CustomTypographyComponent>
          </Stack>
          {headerButtons && headerButtons}
        </DrawerHeader>

        <Divider />
        <Stack id="SideSheetCompomentInnerStack" width="100%" padding={2}>
          {children}
        </Stack>
      </Drawer>
    </ClickAwayListener>
  );
};

export default SideSheetCompoment;
